if (!customElements.get("wishlist-icon")) {
  class WishlistIcon extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (this.hasChildNodes()) this.init();
    }

    init() {
      let wishlistCount = 0;

      try {
        const wishlist = JSON.parse(localStorage.getItem("wishlist") || "[]");
        wishlistCount = wishlist.reduce(
          (total, item) => total + item.quantity,
          0
        );
      } catch (e) {
        console.error("Error parsing wishlist", e);
      }

      this.updateWishlistCount(wishlistCount);

      // Listen for storage changes
      window.addEventListener("storage", (event) => {
        if (event.key === "wishlist") {
          let wishlistCount = 0;
          try {
            const wishlist = JSON.parse(event.newValue || "[]");
            wishlistCount = wishlist.reduce(
              (total, item) => total + item.quantity,
              0
            );
          } catch (e) {
            console.error("Error parsing wishlist", e);
          }
          this.updateWishlistCount(wishlistCount);
        }
      });
    }

    updateWishlistCount(count) {
      const wishlistCountNumber = this.querySelector(
        ".header__wishlist-count-number"
      );
      if (!wishlistCountNumber) return;

      console.log("count", count);

      wishlistCountNumber.textContent = count;

      const wishlistBubble = this.querySelector("#wishlist-icon-bubble");
      if (!wishlistBubble) return;

      if (count > 0) {
        wishlistBubble.classList.remove("hidden");
      } else {
        wishlistBubble.classList.add("hidden");
      }
    }
  }

  customElements.define("wishlist-icon", WishlistIcon);
}
